<section class="grid wwe-info-bar">
	<section class="d-flex flex-wrap justify-content-around align-items-center">
		<div class="col-9 text-align-center text-16-bold">Wealth Web Debug Mode</div>
		<div class="col-3">
			<icon type="toggle-off" *ngIf="!usingMockAPI"></icon>
			<icon type="toggle-on" *ngIf="usingMockAPI"></icon>
			<button dz-button (click)="toggleMockAPIs()">
				<span>{{ mockApiButtonText }}</span>
			</button>
		</div>
	</section>
</section>
